import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import Stars from "@/components/Stars";
import { BadgeCheck, MapPin } from "lucide-react";

export default function TradespersonCard({ tp }) {
  const isUnclaimed = tp.claim_status === "unclaimed";
  return (
    <Link
      to={`/tradespeople/${tp.id}`}
      data-testid={`tradesperson-card-${tp.id}`}
      className="block"
    >
      <Card className={`tf-card-hover h-full ${isUnclaimed ? "border-dashed border-slate-300 bg-slate-50/60" : "border-slate-200"}`}>
        <CardContent className="p-6">
          <div className="flex items-start justify-between gap-2">
            <div>
              <div className={`font-display font-semibold text-lg leading-tight ${isUnclaimed ? "text-slate-700" : "text-slate-900"}`}>
                {tp.name}
              </div>
              {tp.business_name && (
                <div className="text-sm text-slate-600 mt-0.5">{tp.business_name}</div>
              )}
            </div>
            {isUnclaimed ? (
              <Badge
                data-testid="unclaimed-badge"
                variant="outline"
                className="border-slate-300 text-slate-500 bg-white font-normal shrink-0"
              >
                Unclaimed
              </Badge>
            ) : tp.verified ? (
              <Badge
                data-testid="verified-badge"
                className="bg-blue-50 text-blue-900 border-blue-200 hover:bg-blue-50 gap-1 shrink-0"
              >
                <BadgeCheck className="w-3.5 h-3.5" /> Verified
              </Badge>
            ) : null}
          </div>

          <div className="flex items-center gap-1.5 mt-3 text-sm text-slate-500">
            <MapPin className="w-3.5 h-3.5" />
            <span>
              {tp.city}, {tp.province}
            </span>
          </div>

          <div className="flex flex-wrap gap-1.5 mt-4">
            {(tp.categories || []).slice(0, 2).map((c) => (
              <Badge
                key={c}
                variant="outline"
                className="border-slate-200 text-slate-700 font-normal"
              >
                {c}
              </Badge>
            ))}
          </div>

          <div className="flex items-center justify-between mt-5 pt-4 border-t border-slate-100">
            <Stars value={tp.rating || 0} showValue />
            <span className="text-xs text-slate-500">
              {tp.review_count || 0} review{tp.review_count === 1 ? "" : "s"}
            </span>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
